import { IPermissionsData } from './types';

const actions = {
  FETCH_PERMISSIONS_REQUEST: 'PERMISSIONS_FETCH_REQUEST',
  FETCH_PERMISSIONS_SUCCESS: 'PERMISSIONS_FETCH_SUCCESS',
  FETCH_PERMISSIONS_ERROR: 'PERMISSIONS_FETCH_ERROR',

  fetchPermissions: () => ({
    type: actions.FETCH_PERMISSIONS_REQUEST,
  }),

  fetchPermissionsSuccess: (data: IPermissionsData) => ({
    type: actions.FETCH_PERMISSIONS_SUCCESS,
    payload: { data },
  }),

  fetchPermissionsError: () => ({
    type: actions.FETCH_PERMISSIONS_ERROR,
  }),
};

export default actions;
